import React from 'react'
import { useInView } from 'react-intersection-observer';
import CV from '../../assets/cv.pdf'

const CTA = () => {
  const { ref: ctaRef, inView: myElementIsVisible } = useInView();

  let downloadStyle = 'btn '
  downloadStyle += myElementIsVisible ? 'show-from-left' : 'hide-from-left'

  let letstalk = 'btn btn-primary '
  letstalk += myElementIsVisible ? 'show-from-right' : 'hide-from-right'

  return (
    <div className='cta' ref={ctaRef}>
        <a href={CV} download className={downloadStyle}>Download CV</a>
        <a href="#contact" className={letstalk}>Let's Talk</a>
    </div>
  )
}

export default CTA